import { render } from "./UserInfo.vue?vue&type=template&id=19fa6ae2&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=19fa6ae2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fa6ae2"]])

export default __exports__